/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from 'react'

import { StyledItem, StyledItemContent } from './styles'

interface ITabsItemProps {
  href?: string
  color?: string
  placement?: string
  disabled?: boolean
  active: boolean
  onClick?(e: any): void
}

const Item: FunctionComponent<ITabsItemProps> = React.memo(
  ({ color = 'blue', children, onClick, ...props }) => {
    const handleClick = e => {
      if (onClick && !props.disabled) {
        onClick(e)
      }
    }

    return (
      <StyledItem color={color} onClick={handleClick} {...props}>
        <StyledItemContent color={color} disabled={props.disabled}>
          {children}
        </StyledItemContent>
      </StyledItem>
    )
  },
)

Item.displayName = 'Item'
export default Item
